module.exports = __webpack_public_path__ + "img/paypal.b40eb305.svg";